// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"b5810708","434":"f724d20f","845":"7625aef6","954":"14f46e49"}[chunkId] + ".chunk.css";
};